"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushAzureMonitor = exports.shutdownAzureMonitor = exports.useAzureMonitor = exports.KnownSeverityLevel = exports.TelemetryClient = void 0;
// Copyright (c) Microsoft Corporation.
var telemetryClient_1 = require("./shim/telemetryClient");
Object.defineProperty(exports, "TelemetryClient", { enumerable: true, get: function () { return telemetryClient_1.TelemetryClient; } });
var generated_1 = require("./declarations/generated");
Object.defineProperty(exports, "KnownSeverityLevel", { enumerable: true, get: function () { return generated_1.KnownSeverityLevel; } });
var main_1 = require("./main");
Object.defineProperty(exports, "useAzureMonitor", { enumerable: true, get: function () { return main_1.useAzureMonitor; } });
Object.defineProperty(exports, "shutdownAzureMonitor", { enumerable: true, get: function () { return main_1.shutdownAzureMonitor; } });
Object.defineProperty(exports, "flushAzureMonitor", { enumerable: true, get: function () { return main_1.flushAzureMonitor; } });
// To support the shim
__exportStar(require("./shim/applicationinsights"), exports);
//# sourceMappingURL=index.js.map